export const CLASSNAMES_LINK = {
  LAUNCH: 'sage-link sage-link--launch',
  SUBTEXT: 'sage-link sage-link--subtext',
};
